import type { ReactNode } from "react";
import "./quote-materials-workspace.css";

export function QuoteMaterialsWorkspace({ children }: { children: ReactNode }) {
  return <div className="quote-materials-workspace" data-testid="quote-materials-workspace">
    {children}
  </div>;
}
